import React from 'react'

function Error() {
    return (<>
        <div className='m-5'>
            <h1 >Page Not Found</h1>
            <a href='/'>Click here to Redirect</a>
        </div>
    </>
    )
}

export default Error